import Cookies from 'js-cookie'

/** 移除登录信息 */
export function removeUserInfo() {
  const domain = location.host.replace(/.\w+\./, '.');
  ['sectoken', 'us', 'nus', 'cnUser', 'CNMember'].forEach((key) => {
    Cookies.remove(key)
    Cookies.remove(key, { domain })
    Cookies.remove(key, { domain: '.hopegoo.com' })
  })
}
